import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { AlmacenService } from 'src/app/services/api/almacen.service';
import { AventuraService } from 'src/app/services/api/aventura.service';
import { FileService } from 'src/app/services/api/file.service';
import { PdfGeneratorService } from 'src/app/services/pdf-generator.service';
import Swal from 'sweetalert2';
import { DialogAsignarTiposComponent } from './dialog-asignar-tipos/dialog-asignar-tipos.component';
import { DialogPaxComponent } from './dialog-pax/dialog-pax.component';
import { DialogVerDocumentoComponent } from './dialog-ver-documento/dialog-ver-documento.component';

@Component({
  selector: 'app-egreso-equipos',
  templateUrl: './egreso-equipos.component.html',
  styleUrls: ['./egreso-equipos.component.css'],
})
export class EgresoEquiposComponent implements OnInit {
  s3ServiceRoute: any =
    'https://0ehm5uf0oi.execute-api.us-east-2.amazonaws.com/dev/warehouse/api/v1';
  //s3ServiceRoute: any = "http://localhost:3000/api/v1";

  files: any = [];

  displayedColumns: any[] = [
    //'check',
    'fileNumber',
    'productName',
    'fechaOperacion',
    'cantPax',
    'editar',
    'generarOS',
    'ordenSalida',
  ];

  dataSource: any;
  loading: boolean = true;

  selectFile: string | null = null;
  selectProducto: string | null = null;

  arrayFiles: any = [];
  arrayProductos: any = [];

  startDate: Date | any;
  endDate: Date | any;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(
    private http: HttpClient,
    private pdfGeneratorService: PdfGeneratorService,
    private router: Router,
    private aventuraService: AventuraService,
    private fileService: FileService,
    private almacenService: AlmacenService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.getAllFilesProductsAventura().then((fileProducts) => {
      console.log({
        fileProducts,
      });
      this.files = fileProducts;

      const file = this.files
        .filter(
          (item: any) => item.fileNumber !== '' && item.fileNumber !== null,
        )
        .map((item: any) => item.fileNumber);
      const producto = this.files
        .filter(
          (item: any) => item.productName !== '' && item.productName !== null,
        )
        .map((item: any) => item.productName);

      this.arrayFiles = [...new Set(file)];
      this.arrayProductos = [...new Set(producto)];

      this.dataSource = new MatTableDataSource(this.files);
      this.dataSource.paginator = this.paginator;
      this.loading = false;
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async getAllFilesProductsAventura() {
    try {
      let lastEvaluatedKeyId: string | null = null;
      let fileProducts: any[] = [];
      do {
        const getAllFileProductsAventuraResponse: any = await firstValueFrom(
          this.almacenService.queryGetAllFileProductsAventura({
            exclusiveStartKeyId: lastEvaluatedKeyId,
          }),
        );

        console.log(lastEvaluatedKeyId);

        fileProducts = fileProducts.concat(
          getAllFileProductsAventuraResponse.getAllFileProductsAventura
            ?.productFiles || [],
        );
        console.log({
          fileProducts,
        });

        lastEvaluatedKeyId =
          getAllFileProductsAventuraResponse.getAllFileProductsAventura
            ?.lastEvaluatedKeyId || null;
      } while (lastEvaluatedKeyId);

      return fileProducts;
    } catch (unknownError) {
      console.warn(
        'Error unknown while fetching file products at getAllFiles function',
        unknownError,
      );
      console.trace(
        'Stack trace for the unknown error at getAllFiles function',
      );
      return [];
    }
  }

  openDialogPax(element: any): void {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      element,
    };
    dialogConfig.width = '100rem';
    dialogConfig.height = '500px';

    let dialogRef = this.dialog.open(DialogPaxComponent, dialogConfig);
  }

  openDialogAsignarTipoEquipo(file: any): void {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      file: file,
    };
    dialogConfig.width = '43rem';
    dialogConfig.height = '550px';

    let dialogRef = this.dialog.open(DialogAsignarTiposComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      console.log('closed');
      console.log(result);
      if (result == 1) {
        //this.getAllEquipos();
      }
    });
  }

  navigateToDetalle(element: any) {
    this.router
      .navigate([`/asignar/${element.fileId}/${element.productId}`])
      .then(() => console.log('Navigated to Detalle'));
  }

  applyFilterSelect() {
    let dataNew: any = this.files;
    if (this.selectFile) {
      dataNew = dataNew?.filter(
        (item: any) => item.fileNumber === this.selectFile,
      );
    }
    if (this.selectProducto) {
      dataNew = dataNew?.filter(
        (item: any) => item.productName === this.selectProducto,
      );
    }
    if (this.startDate && this.endDate) {
      dataNew = dataNew?.filter((item: any) => {
        return (
          new Date(this.startDate) <=
            moment(item.fechaInicio, 'DD.MM.YYYY').toDate() &&
          moment(item.fechaFin, 'DD.MM.YYYY').toDate() <= new Date(this.endDate)
        );
      });
    }

    this.dataSource.data = dataNew;
  }

  cleanDateSelected() {
    this.startDate = null;
    this.endDate = null;

    this.applyFilterSelect();
  }

  updateCheck(row: any) {
    row.checked = !row.checked;

    this.files.map((file: any) => {
      if (file.fileId === row.fileId) {
        file.checked = row.checked;
      }
    });
  }

  generarOrdenSalida(element: any) {
    console.log(element);

    if (element.numberOrdenSalida) {
      this.almacenService
        .deleteOrdenSalida(element.idOrdenSalida)
        .subscribe((res: any) => {
          this.almacenService
            .createOrdenSalida({
              itineraryId: element.fileId,
              fileNumber: element.fileNumber,
              productId: element.productId,
            })
            .subscribe(async (res: any) => {
              this.generarPDF(
                element.fileId,
                element.productId,
                res.createOrdenSalida.ordenSalidaNumber,
                element,
                {
                  fileNumber: element.fileNumber,
                  ruta: element.productName,
                  cantPax: element.cantPax,
                },
              );
            });
        });
    } else {
      this.almacenService
        .createOrdenSalida({
          itineraryId: element.fileId,
          fileNumber: element.fileNumber,
          productId: element.productId,
        })
        .subscribe(async (res: any) => {
          this.generarPDF(
            element.fileId,
            element.productId,
            res.createOrdenSalida.ordenSalidaNumber,
            element,
            {
              fileNumber: element.fileNumber,
              ruta: element.productName,
              cantPax: element.cantPax,
            },
          );
        });
    }
  }

  /*   generarOrdenSalida(){

      const checked=this.dataSource.data.filter((data:any)=>data.checked)

      const fileId=checked[0].fileId
      const fileNumber=checked[0].fileNumber
      if(checked.every((el:any)=>el.fileId===fileId)){

        this.almacenService.createOrdenSalida({
          itineraryId:fileId,
          fileNumber:fileNumber
        }).subscribe(async (res:any)=>{
          console.log(res)

          await firstValueFrom(this.fileService.updateItinerary(fileId,{numberOrdenSalida:res.createOrdenSalida.ordenSalidaNumber}))

          this.generarPDF(fileId,res.createOrdenSalida.ordenSalidaNumber,checked,{fileNumber:fileNumber,ruta:checked[0].productName,cantPax:checked[0].cantPax})
        })

        //this.generarPDF(fileId)
      }
      else{
        Swal.fire({
          position: 'top-end',
          title: 'Debe elegir las rutas de un solo file',
          icon:"warning",
          showConfirmButton: false,
          timer: 5000
        }
      )
      }

    } */

  agruparPorEquipoId(array: any) {
    const grupos: Record<string, any[]> = {};

    array.forEach((elemento: any) => {
      if (!grupos[elemento.equipoId]) {
        grupos[elemento.equipoId] = [];
      }
      // Verificar si el elemento ya ha sido agregado
      const equipoInventarioId = elemento.equipoInventarioId;
      if (
        !grupos[elemento.equipoId].some(
          (el) => el.equipoInventarioId === equipoInventarioId,
        )
      ) {
        grupos[elemento.equipoId].push(elemento);
      }
    });

    return Object.keys(grupos).map((equipoId) => ({
      equipoId,
      elementos: grupos[equipoId],
    }));
  }

  getNamesProviders(services: any, filter: any) {
    let filtered;
    if (filter === 'GUIA')
      filtered = services.filter(
        (service: any) =>
          service.tipoServicio === filter &&
          service.categoriaServicio !== 'ASISTENTE' &&
          service.categoriaServicio !== 'ASISTENTEGUIAMONTAÑA',
      );
    else if (filter === 'ASISTENTEGUIA')
      filtered = services.filter(
        (service: any) =>
          service.categoriaServicio === 'ASISTENTE' ||
          service.categoriaServicio === 'ASISTENTEGUIAMONTAÑA',
      );
    else {
      filtered = services.filter(
        (service: any) => service.categoriaServicio === filter,
      );
    }

    const uniqueNames = new Set(
      filtered.map((elemento: any) => elemento.objProvider.nombre),
    );

    return Array.from(uniqueNames).join(',');
  }

  getTotalServices(services: any, filter: any) {
    let filtered;
    if (filter === 'PORTEADOR')
      filtered = services.filter(
        (service: any) =>
          service.categoriaServicio === 'PORTEADOR' ||
          service.categoriaServicio === 'PORTEADORBAÑERO' ||
          service.categoriaServicio === 'PORTEADOREXTRA' ||
          service.categoriaServicio === 'PORTEADORMENAJERO',
      );
    else
      filtered = services.filter(
        (service: any) =>
          service.categoriaServicio === 'ACEMILA' ||
          service.categoriaServicio === 'ACEMILACARGA' ||
          service.categoriaServicio === 'ACEMILASILLA',
      );

    return filtered.length;
  }

  async generarPDF(
    fileId: any,
    productId: any,
    ordenSalidaNumber: any,
    element: any,
    fileData: any,
  ) {
    const servicesData = (
      await firstValueFrom(
        this.almacenService.getServicesDataForPdf(fileId, productId),
      )
    ).getServicesDataForPdf;

    console.log(servicesData);

    fileData = {
      ...fileData,
      guia: this.getNamesProviders(servicesData, 'GUIA'),
      asistGuia: this.getNamesProviders(servicesData, 'ASISTENTEGUIA'),
      cocinero: this.getNamesProviders(servicesData, 'COCINERO'),
      asistCocina: this.getNamesProviders(servicesData, 'ASISTENTECOCINA'),
      jefePorter: this.getNamesProviders(servicesData, 'JEFEPORTEADOR'),
      jefeArriero: this.getNamesProviders(servicesData, 'JEFEARRIERO'),
      totalPorter: this.getTotalServices(servicesData, 'PORTEADOR'),
      totalAcemila: this.getTotalServices(servicesData, 'ACEMILA'),
    };

    console.log(fileData);

    const egresos = (
      await firstValueFrom(
        this.almacenService.getAllEgresoEquiposByFileAndProductId(
          fileId,
          productId,
        ),
      )
    ).getAllEgresoEquiposByFileAndProductId;

    const grupos = this.agruparPorEquipoId(egresos);

    await Promise.all(
      grupos.map(async (el: any) => {
        await Promise.all(
          el.elementos.map(async (equipo: any) => {
            equipo.equipoInfo = (
              await firstValueFrom(
                this.aventuraService.getEquipoInventario(
                  equipo.equipoInventarioId,
                ),
              )
            ).getEquipoInventario;
          }),
        );
      }),
    );

    const pdfData: any[] = [];

    grupos.map((el: any) => {
      console.log(el);
      pdfData.push({
        equipo:
          el.elementos[0].equipoInfo?.nombreEquipo +
          ' ' +
          el.elementos[0].equipoInfo?.marcaEquipo +
          ' ' +
          el.elementos[0].equipoInfo?.modeloEquipo,
        cantidad: el.elementos.length,
        codigo: el.elementos
          .map((elemento: any) => elemento.equipoInfo.codigo)
          .join(','),
        estado: el.elementos
          .map((elemento: any) => elemento.equipoInfo.observacionEquipo)
          .join(','),
      });
    });

    console.log(pdfData);

    const pdf = this.pdfGeneratorService.generatePdf(
      pdfData,
      ['Equipo', 'Cantidad', 'Código', 'Estado'],
      fileData,
      ordenSalidaNumber,
    );

    this.http
      .post(`${this.s3ServiceRoute}/addFileOrdenSalida`, {
        data: pdf,
        fileId: ordenSalidaNumber,
      })
      .subscribe((response: any) => {
        element.numberOrdenSalida = ordenSalidaNumber;

        Swal.fire({
          position: 'top-end',
          title: 'La orden de salida fue generada con éxito',
          icon: 'success',
          showConfirmButton: false,
          timer: 5000,
        });
      });
  }

  openDialogVerPdf(element: any) {
    console.log(element);
    let dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      data: element,
    };
    dialogConfig.width = '50rem';
    dialogConfig.height = '38rem';

    let dialogRef = this.dialog.open(DialogVerDocumentoComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {});
  }
}
